import { webKnots } from 'src/features/brands/atoms/canvas/common/back/lace/webKnots'
import { jointOfCatchFace, jointOfIndexFinger, jointOfThumbFinger2 } from './parts/earJointParts'
import { topSidePartOfWebForPicher } from './parts/sideParts'

export const flatVLaceWeb = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  // web先端の革パーツ
  topSidePartOfWebForPicher(ctx, webColor, laceColor, stitchColor)
  // ウェブ-人差し指のジョイントパーツ
  jointOfIndexFinger(ctx, webColor, laceColor, 3, 30)
  jointOfIndexFinger(ctx, webColor, laceColor, -24, 90)
  jointOfIndexFinger(ctx, webColor, laceColor, -45, 160)
  jointOfCatchFace(ctx, webColor, laceColor, -10, 12)
  jointOfCatchFace(ctx, webColor, laceColor, 38, 57)
  jointOfThumbFinger2(ctx, webColor, laceColor, 53, -56)
  jointOfThumbFinger2(ctx, webColor, laceColor, 19, -30)
  jointOfThumbFinger2(ctx, webColor, laceColor, -18, -5)
  // web本体のflatパーツ
  ctx.fillStyle = webColor
  ctx.beginPath()
  ctx.moveTo(549, 81) // 左上
  ctx.quadraticCurveTo(502, 166, 482, 247) // 左下1
  ctx.quadraticCurveTo(480, 256, 486, 268) // 左下2
  ctx.quadraticCurveTo(516, 326, 565, 357) // 右下1
  ctx.quadraticCurveTo(571, 362, 582, 362) // 右下2
  ctx.quadraticCurveTo(637, 324, 693, 280) // 右上
  ctx.quadraticCurveTo(660, 140, 549, 81) // 左上
  ctx.fill()
  // デザインライン
  ctx.moveTo(633, 151) // 左上
  ctx.quadraticCurveTo(626, 182, 626, 182) // 下1
  ctx.quadraticCurveTo(652, 177, 652, 177) // 右上1
  //
  ctx.moveTo(618, 134) // 左上
  ctx.quadraticCurveTo(606, 200, 606, 200) // 下1
  ctx.quadraticCurveTo(661, 193, 661, 193) // 右上1
  //
  ctx.moveTo(600, 116) // 左上
  ctx.quadraticCurveTo(586, 223, 586, 223) // 下1
  ctx.quadraticCurveTo(670, 213, 670, 213) // 右上1
  //
  ctx.moveTo(579, 101) // 左上
  ctx.quadraticCurveTo(564, 254, 564, 254) // 下1
  ctx.quadraticCurveTo(680, 237, 680, 237) // 右上1
  //
  ctx.moveTo(550, 125) // 左上
  ctx.quadraticCurveTo(539, 284, 539, 284) // 下1
  ctx.quadraticCurveTo(664, 268, 664, 268) // 右上1
  ctx.quadraticCurveTo(623, 298, 623, 298) // 右下
  ctx.quadraticCurveTo(537, 311, 537, 311) // 中央下＿右
  ctx.quadraticCurveTo(513, 288, 513, 288) // 中央下＿左
  ctx.quadraticCurveTo(523, 177, 523, 177) //
  ctx.quadraticCurveTo(550, 125, 550, 125) // 左上
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // 外側
  ctx.moveTo(552, 87) // 左上
  ctx.quadraticCurveTo(508, 166, 486, 252) // 左下
  ctx.quadraticCurveTo(505, 318, 581, 358) // 右下
  ctx.quadraticCurveTo(630, 326, 689, 277) // 右上1
  ctx.quadraticCurveTo(678, 241, 678, 241) // 右上2
  // 内1
  ctx.moveTo(636, 154) // 左上
  ctx.quadraticCurveTo(630, 177, 630, 177) // 下
  ctx.quadraticCurveTo(648, 174, 648, 174) // 下
  // 内2
  ctx.moveTo(614, 132) // 左上
  ctx.quadraticCurveTo(602, 203, 602, 203) // 下
  ctx.quadraticCurveTo(661, 196, 661, 196) // 下
  // 内3
  ctx.moveTo(603, 118) // 左上
  ctx.quadraticCurveTo(590, 218, 590, 218) // 下
  ctx.quadraticCurveTo(667, 210, 667, 210) // 下
  // 内4
  ctx.moveTo(550, 86) // 左上
  ctx.quadraticCurveTo(576, 100, 576, 100) // 下
  ctx.quadraticCurveTo(561, 257, 561, 257) // 下
  ctx.quadraticCurveTo(679, 241, 679, 241) // 下
  // 内5
  ctx.moveTo(552, 117) // 左上
  ctx.quadraticCurveTo(519, 175, 519, 175) // 下
  ctx.quadraticCurveTo(509, 288, 509, 288) // 下
  ctx.quadraticCurveTo(535, 313, 535, 313) // 下
  ctx.quadraticCurveTo(623, 301, 623, 301) // 下
  ctx.quadraticCurveTo(672, 265, 672, 265) // 下
  ctx.quadraticCurveTo(543, 278, 543, 278) //
  ctx.quadraticCurveTo(552, 117, 552, 117) //
  ctx.moveTo(553, 88) // 左上
  ctx.quadraticCurveTo(508, 191, 508, 191) // 下
  ctx.quadraticCurveTo(516, 192, 516, 192) //
  ctx.quadraticCurveTo(498, 208, 498, 208) //
  ctx.quadraticCurveTo(513, 218, 513, 218) //
  ctx.quadraticCurveTo(488, 243, 488, 243) //
  ctx.quadraticCurveTo(510, 253, 510, 253) //
  ctx.quadraticCurveTo(493, 273, 493, 273) //
  ctx.quadraticCurveTo(516, 308, 558, 342) //
  ctx.quadraticCurveTo(560, 309, 560, 309) //
  ctx.quadraticCurveTo(593, 346, 593, 346) //
  ctx.quadraticCurveTo(594, 304, 594, 304) //
  ctx.quadraticCurveTo(619, 331, 619, 331) //
  ctx.quadraticCurveTo(622, 299, 622, 299) //
  ctx.quadraticCurveTo(633, 312, 635, 313) //
  ctx.quadraticCurveTo(667, 293, 687, 270) //
  // ctx.quadraticCurveTo() //
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで
  webKnots(ctx, laceColor, -90, 80, 1) // ウェブ先端寄りのウェブ結び目
  webKnots(ctx, laceColor, -110, 110, 1) // ウェブ先端寄りのウェブ結び目

  ctx.beginPath()
  ctx.moveTo(582, 219) // 左上
  ctx.quadraticCurveTo(576, 226, 576, 226) // 左下
  ctx.quadraticCurveTo(577, 230, 588, 235) // 右下
  ctx.quadraticCurveTo(593, 228, 593, 228) // 右上
  ctx.quadraticCurveTo(582, 221, 582, 219) // 左上
  ctx.fill()
  ctx.moveTo(581, 221) // 左上
  ctx.quadraticCurveTo(582, 225, 591, 229) // 右上
  ctx.stroke()
  ctx.closePath()

  laceOfDesign1(ctx, laceColor, 20, 19)
  laceOfDesign1(ctx, laceColor, 17, 36)
  laceOfDesign1(ctx, laceColor, 14, 55)
  laceOfDesign1(ctx, laceColor, 12, 77)
  //
  laceOfDesign1(ctx, laceColor, -25, 15)
  laceOfDesign1(ctx, laceColor, -27, 35)
  laceOfDesign1(ctx, laceColor, -30, 55)
  laceOfDesign1(ctx, laceColor, -31, 75)
  laceOfDesign1(ctx, laceColor, -33, 97)
  laceOfDesign1(ctx, laceColor, -35, 120)
  laceOfDesign1(ctx, laceColor, -35, 140)
  //
  laceOfDesign2(ctx, laceColor, 3, 1)
  laceOfDesign2(ctx, laceColor, -15, 3)
  laceOfDesign2(ctx, laceColor, -33, 5)
  laceOfDesign2(ctx, laceColor, -53, 5)
  //
  laceOfDesign2(ctx, laceColor, -99, 68)
  laceOfDesign2(ctx, laceColor, -83, 65)
  laceOfDesign2(ctx, laceColor, -66, 63)
  laceOfDesign2(ctx, laceColor, -50, 61)
  laceOfDesign2(ctx, laceColor, -35, 59)
  laceOfDesign2(ctx, laceColor, -20, 57)
  laceOfDesign2(ctx, laceColor, -5, 55)

  webKnots(ctx, laceColor, -50, -100, 1) // ウェブ先端寄りのウェブ結び目
  webKnots(ctx, laceColor, 60, 10, 1) // ウェブ先端寄りのウェブ結び目
}

const laceOfDesign1 = (ctx: CanvasRenderingContext2D, laceColor: string, x: number, y: number): void => {
  ctx.fillStyle = laceColor
  ctx.beginPath()
  ctx.moveTo(567 + x, 132 + y) // 左上
  ctx.quadraticCurveTo(564 + x, 137 + y, 566 + x, 143 + y) // 左下
  ctx.quadraticCurveTo(582 + x, 131 + y, 582 + x, 134 + y) // 右下
  ctx.quadraticCurveTo(585 + x, 128 + y, 583 + x, 123 + y) // 右上
  ctx.quadraticCurveTo(573 + x, 126 + y, 567 + x, 132 + y) // 左上
  ctx.fill()
  ctx.moveTo(566 + x, 143 + y) // 左上
  ctx.quadraticCurveTo(572 + x, 132 + y, 584 + x, 130 + y) // 右下
  ctx.stroke()
  ctx.closePath()
}

const laceOfDesign2 = (ctx: CanvasRenderingContext2D, laceColor: string, x: number, y: number): void => {
  ctx.fillStyle = laceColor
  ctx.beginPath()
  ctx.moveTo(646 + x, 207 + y) // 左上
  ctx.quadraticCurveTo(649 + x, 225 + y, 649 + x, 225 + y) // 左下1
  ctx.quadraticCurveTo(655 + x, 227 + y, 657 + x, 224 + y) // 右下1
  ctx.quadraticCurveTo(657 + x, 209 + y, 654 + x, 203 + y) // 右上
  ctx.quadraticCurveTo(648 + x, 203 + y, 646 + x, 207 + y) // 左上
  ctx.fill()
  ctx.moveTo(647 + x, 204 + y) // 左上
  ctx.quadraticCurveTo(652 + x, 225 + y, 649 + x, 225 + y) // 左下1
  ctx.stroke()
  ctx.closePath()
}
